
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/status-klienta",
      function () {
        return require("private-next-pages/status-klienta.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/status-klienta"])
      });
    }
  